import React from 'react';

export const Search = ({ height = 20, width = 20, fill = '#818998' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 17"
        fill="none"
    >
        <path
            d="M15.9678 15.5273L11.7987 11.3582C12.8816 10.0337 13.4141 8.34365 13.2859 6.63757C13.1577 4.93149 12.3787 3.33995 11.11 2.19214C9.84125 1.04433 8.17989 0.428071 6.46953 0.470836C4.75918 0.5136 3.1307 1.21211 1.92092 2.42189C0.711137 3.63167 0.0126232 5.26016 -0.0301409 6.97051C-0.0729051 8.68086 0.543352 10.3422 1.69116 11.611C2.83897 12.8797 4.43051 13.6587 6.13659 13.7869C7.84267 13.9151 9.53275 13.3826 10.8573 12.2996L15.0264 16.4688L15.9678 15.5273ZM6.64687 12.4741C5.59344 12.4741 4.56367 12.1617 3.68778 11.5764C2.81188 10.9912 2.12921 10.1593 1.72608 9.18611C1.32295 8.21287 1.21747 7.14194 1.42298 6.10875C1.6285 5.07556 2.13577 4.12652 2.88066 3.38163C3.62554 2.63675 4.57459 2.12947 5.60778 1.92396C6.64096 1.71845 7.71189 1.82392 8.68513 2.22705C9.65837 2.63018 10.4902 3.31286 11.0755 4.18875C11.6607 5.06465 11.9731 6.09442 11.9731 7.14785C11.9715 8.55996 11.4099 9.91379 10.4113 10.9123C9.41281 11.9108 8.05899 12.4725 6.64687 12.4741Z"
            fill={fill}
        />
    </svg>
);
